export const mockData = {
  name: 'Rushikesh Ladke',
  headLine:
    'Restructured a plotting algorithm for a stickers printing platform allowing paid 50K+ users to plot structures to 0.01 mm precision ',
  currentJobTitle: 'Full-Stack Developer',
  companyAndLocation: 'Lorem Ipsum, India',
  jobRole: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries.`,
  skills: [
    {
      id: 1,
      name: 'JavaScript',
      experience: '2 Years of experience',
      description: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries`,
    },
    {
      id: 2,
      name: 'React',
      experience: '2 Years of experience',
      description: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries`,
    },
  ],
  moreInformation: [
    {
      id: 1,
      content: 'Languages: Lorem Ipsum is simply dumm',
    },
    {
      id: 2,
      content: 'Frontend Libraries & Frameworks: Lorem Ipsum is simply dumm',
    },
    {
      id: 3,
      content: 'Backend Libraries & Frameworks: Lorem Ipsum is simply dumm',
    },
    {
      id: 4,
      content: 'Cloud: Lorem Ipsum is simply dumm',
    },
  ],
  education: [
    {
      id: 1,
      content: 'Pursuing Master of Science in AI and ML',
    },
    {
      id: 2,
      content: 'Engineering Fellow, Pesto Tech, 2021',
    },
    {
      id: 3,
      content: 'Bachelor of computer Engineering, VIT, 2020',
    },
  ],
  professionalExperience: "Aug '20 - Present sadasdadas d asd sad",
  job: [
    {
      id: 1,
      nameAndPosition: 'Lorem Ipsum, Pune(India) - Software Engineer',
      tenure: 'January 2020 - Present 1 Year 1 Month',
      description: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries,`,
      roleInCompany:
        'Tech Stack: React, Nextjs, Gatsby, Nextjs, HTML, and SaSS',
      moreInfo: [
        {
          id: 1,
          content:
            'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry',
        },
        {
          id: 2,
          content:
            'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry',
        },
        {
          id: 3,
          content:
            'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry',
        },
      ],
    },
    {
      id: 2,
      nameAndPosition: 'Lorem Ipsum, Pune(India) - Software Engineer',
      tenure: 'January 2020 - Present 1 Year 1 Month',
      description: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries,`,
      roleInCompany:
        'Tech Stack: React, Nextjs, Gatsby, Nextjs, HTML, and SaSS',
      moreInfo: [
        {
          id: 1,
          content:
            'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry',
        },
        {
          id: 2,
          content:
            'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry',
        },
        {
          id: 3,
          content:
            'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry',
        },
      ],
    },
  ],
};
